import { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { selectIsCountrysideTrapEnabled, selectSource, selectVillagesLink } from '../../../../selectors';
import { ISuburbanCatalog, TSuburbanCatalog } from '../../../../types/suburbanCatalog';
import { trackBannerBuildersClick, trackBannerKpLinkClick, trackTrapKpLinkClick } from '../tracking';
import { selectJsonQuery } from 'shared/selectors/results';

export const useCatalogs = (catalogsTypes: TSuburbanCatalog[]): ISuburbanCatalog[] => {
  const isCountrysideTrapEnabled = useSelector(selectIsCountrysideTrapEnabled);
  const villagesLink = useSelector(selectVillagesLink);

  const jsonQuery = useSelector(selectJsonQuery);
  const source = useSelector(selectSource);

  const trackClick = isCountrysideTrapEnabled ? trackTrapKpLinkClick : trackBannerKpLinkClick;

  const handleKPClick = useCallback(() => {
    trackClick(jsonQuery, source);
  }, [jsonQuery, source, trackClick]);

  const handleBannerBuildersClick = useCallback(() => {
    trackBannerBuildersClick(jsonQuery, source);
  }, [jsonQuery, source]);

  return useMemo(() => {
    return catalogsTypes.reduce<ISuburbanCatalog[]>((catalogs, type) => {
      let catalog: ISuburbanCatalog | undefined;

      if (type === 'villages' && villagesLink) {
        catalog = {
          title: 'Коттеджные посёлки',
          description: 'Выгодные предложения и скидки от застройщиков',
          icon: 'villages',
          link: villagesLink,
          onClick: handleKPClick,
        };
      } else if (type === 'builders') {
        catalog = {
          title: 'Построить дом',
          description: 'Надёжные компании и проекты домов на любой вкус',
          icon: 'builders',
          link: '/country-builders-projects/?utm_medium=listing&utm_content=teaser',
          onClick: handleBannerBuildersClick,
        };
      }

      return catalog ? catalogs.concat(catalog) : catalogs;
    }, []);
  }, [catalogsTypes, villagesLink, handleKPClick, handleBannerBuildersClick]);
};
